<template>
    <v-tab-item :value="$route.path" class="pa-3">
        <v-toolbar flat height="90">
            <v-spacer></v-spacer>
            <v-col cols="4" class="pa-0">
                <b-search-field
                    v-model="search"
                    :selectedSearchType="selectedSearchType"
                    :searchTypes="searchTypes"
                ></b-search-field>
            </v-col>
        </v-toolbar>

        <v-data-table
            :headers="headers"
            :items="financialData"
            :footer-props="{
                itemsPerPageOptions: [12],
                showCurrentPage: true,
                pageText: `${page * 12 - 11}-${
                    page * 12 <= serverItemsLength
                        ? page * 12
                        : serverItemsLength
                } ${translations.paginationText[lang]} ${serverItemsLength}`,
            }"
            :page.sync="page"
            :server-items-length="serverItemsLength"
            :loading="loading"
            disable-sort
            class="b-outlined"
        ></v-data-table>
    </v-tab-item>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import debounce from "lodash/debounce";
import translations from "@/utils/translations/loyaltyPanel/stores/financialData";

export default {
    name: "FinancialData",

    mixins: [translations],

    data() {
        return {
            searchTypes: [
                "All Fields",
                "Name",
                "Name of Shop(in app)",
                "Customer",
                "Transaction",
                "Total",
                "Points",
            ],
            selectedSearchType: "All Fields",
            page: +this.$route.query.page,
            mode: 0,
            search: "",
        };
    },

    computed: {
        ...mapState(["loading", "errorMessage", "serverItemsLength"]),
        ...mapState("loyaltyPanel/stores/storesTab", ["financialData"]),

        lang() {
            return this.$route.params.lang;
        },

        headers() {
            return [
                {
                    text: this.translations.name[this.lang],
                    value: "name",
                },
                {
                    text: this.translations.storeName[this.lang],
                    value: "app_name",
                },
                {
                    text: this.translations.customer[this.lang],
                    value: "customers",
                },
                {
                    text: this.translations.transaction[this.lang],
                    value: "transactions",
                },
                { text: this.translations.income[this.lang], value: "income" },
                { text: this.translations.points[this.lang], value: "points" },
            ];
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
    },

    methods: {
        ...mapActions("loyaltyPanel/stores/storesTab", ["getFinancialData"]),

        handleSearch() {
            this.getFinancialData(`?q=${this.search}`);
        },
    },

    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.push({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }
            this.getFinancialData(this.query);
        },

        page(page) {
            this.$router.push({ query: { ...this.$route.query, page } });
        },

        search(val) {
            if (val == null) {
                this.getFinancialData(this.query);
            } else {
                this.debouncedSearch();
            }
        },
    },

    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.push({
                query: {
                    page: 1,
                    ...this.$route.query,
                },
            });
        }
    },

    mounted() {
        this.getFinancialData(this.query);
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
    },
};
</script>
